import { MarketCode } from '../markets/types';
import { AdsConfig } from './types';
import * as appnexus from './appnexus';

const common = {
  service: 'appnexus',
  appnexus: appnexus.defaultConfig,
  headerBiddingEnabled: false,
};

export const adsConfig: Record<Exclude<MarketCode, 'te'>, AdsConfig> = {
  dk: common,
  fi: common,
  fr: common,
  gb: common,
  no: { ...common, appnexus: appnexus.no },
  nz: { ...common, labelAlign: 'bottom' },
  se: {
    ...common,
    appnexus: appnexus.se,
  },
};
